import { useTheme } from '@emotion/react';

import { Sizes } from 'chatie-design-system';
import { DoubleBalloon, Icon } from 'chatie-design-system/icon';

import { OnClickProps } from '../../utils/misc';
import { FloatingButton } from '../layout/FloatingButtonArea';

const DonationButton = ({ onClick }: OnClickProps) => {
  const theme = useTheme();

  return (
    <FloatingButton onClick={onClick}>
      <Icon icon={DoubleBalloon} size={Sizes.large} color={theme.true.white} />
    </FloatingButton>
  );
};

export default DonationButton;
